/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { GDPRConsentResponse } from './GDPRConsentResponse';
import {
    GDPRConsentResponseFromJSON,
    GDPRConsentResponseFromJSONTyped,
    GDPRConsentResponseToJSON,
} from './GDPRConsentResponse';

/**
 * 
 * @export
 * @interface PutConsentGdpr200Response
 */
export interface PutConsentGdpr200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PutConsentGdpr200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PutConsentGdpr200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GDPRConsentResponse}
     * @memberof PutConsentGdpr200Response
     */
    result: GDPRConsentResponse;
}

/**
 * Check if a given object implements the PutConsentGdpr200Response interface.
 */
export function instanceOfPutConsentGdpr200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function PutConsentGdpr200ResponseFromJSON(json: any): PutConsentGdpr200Response {
    return PutConsentGdpr200ResponseFromJSONTyped(json, false);
}

export function PutConsentGdpr200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PutConsentGdpr200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': GDPRConsentResponseFromJSON(json['result']),
    };
}

export function PutConsentGdpr200ResponseToJSON(value?: PutConsentGdpr200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': GDPRConsentResponseToJSON(value.result),
    };
}

